import type { ReportData } from '@weft/types';
import type { PartialNever } from '@weft/utils';
import { useDeleteReport } from 'apps/app/src/hooks/requests/use-delete-report';
import { runMutation } from 'apps/app/src/utils/vy-mutation';
import { useQueryClient } from 'react-query';
import type { VyTableMinimalProps } from '../../../../../../components/new-design/table/vy-table/VyTable';
import { VyTable } from '../../../../../../components/new-design/table/vy-table/VyTable';
import type { ReportJobsDownloadProps } from '../ReportJobsSection';
import { REPORT_DATA_KEYS, getReportJobsColumns } from './ReportJobsTableColumns';

type ReportJobsTableProps = (Required<ReportJobsDownloadProps> | PartialNever<ReportJobsDownloadProps>) & VyTableMinimalProps<ReportData>;

export const ReportJobsTable: React.FC<ReportJobsTableProps> = ({ asDownload, onDownload, ...props }) => {
  const queryClient = useQueryClient();

  const deleteReportMutation = useDeleteReport({
    onSuccess: () => queryClient.invalidateQueries(['reports']),
  });

  const handleDelete = async (reportId: string) => {
    await runMutation(
      deleteReportMutation,
      { reportId },
      {
        pending: 'Deleting report...',
        success: 'Report successfully deleted',
        error: 'Failed to delete report',
      });
  };
  
  const columns = getReportJobsColumns(handleDelete, onDownload);
  
  return (
    <>
      <VyTable
        columns={columns}
        {...props}
        getRowId={() => crypto.randomUUID()}
        initialState={{
          sorting: {
            sortModel: [{ field: REPORT_DATA_KEYS.CREATED_AT, sort: 'desc' }],
          },
        }}
        getRowClassName={() => 'group'}
        sx={{
          paddingBottom: '72px',
        }}
      />
    </>
  );
};